import { render } from "./AddFromPhoto.vue?vue&type=template&id=6d8389c2&scoped=true"
import script from "./AddFromPhoto.vue?vue&type=script&lang=js"
export * from "./AddFromPhoto.vue?vue&type=script&lang=js"

import "./AddFromPhoto.vue?vue&type=style&index=0&id=6d8389c2&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d8389c2"]])

export default __exports__